<template>
    <main id="yagish_about">
        <section class="hero_block">
            <h2 class="h2_other renew2_wrapper">유용한 정보</h2>
        </section>

        <section id="article" class="article">
            <div class="article__hero">
                <h1>자기 PR 이렇게 쓰면 합격률 UP! 실전 팁 & 예시</h1>
                <img src="/kr/resume/static/img/article/article_guide_mv05.jpg" alt="자기 PR 이렇게 쓰면 합격률 UP! 실전 팁 & 예시"
                    class="mvimg">
                <p>
                    이력서는 단순한 경력 목록이 아닙니다. 그중에서도 ‘자기 PR’은 지원자의 강점과 가치를 강조하여 채용 담당자에게 강한 인상을 남길 수 있는 중요한 요소입니다.
                </p>

                <p>
                    하지만 막상 자기 PR을 작성하려고 하면 막막함을 느끼는 경우가 많습니다. ‘내 강점은 무엇일까?’, ‘어떻게 써야 눈에 뛸까?’ 하는 고민이 생기기 마련이죠.
                </p>

                <p>
                    이 기사에서는 효과적인 자기 PR을 작성하는 방법과 기업이 주목하는 포인트를 상세히 설명합니다. 또한, 신입 및 경력직 지원자를 위한 예시와 템플릿을 제공하여 누구나 쉽게 활용할
                    수 있도록 도와드리겠습니다.
                </p>

                <p>
                    지금부터 매력적인 자기 PR을 완성하는 방법을 알아보겠습니다!
                </p>
            </div>


            <div class="article__contents">
                <h2>자기 PR이란? 왜 중요한가?</h2>
                <p>
                    이력서의 자기 PR은 지원자의 강점과 가치를 강조하는 중요한 항목입니다. 단순히 경력을 나열하는 것이 아니라, 자신이 기업에 어떻게 기여할 수 있는지를 설득력 있게 전달해야
                    합니다. 인사 담당자는 자기 PR을 통해 지원자의 능력, 성향, 성장 가능성을 판단하고, 최종 면접으로 이어질지 여부를 결정합니다.
                </p>

                <h3>자기 PR의 역할과 의미</h3>
                <p>
                    자기 PR은 단순한 자기소개가 아닙니다. 이는 지원자의 강점과 경험을 구체적으로 어필하여, 기업이 ‘이 사람을 채용해야겠다’고 느끼도록 만드는 요소입니다.자기 PR의 주요 역할은
                    다음과 같습니다.자신의 강점을 부각: 지원 직무와 관련된 핵심 역량과 성과를 강조합니다.기업과의 연결성 어필: 단순한 능력 자랑이 아니라, 해당 기업에서 어떻게 기여할 수 있는지를
                    보여줍니다.차별화된 인재임을 강조: 다른 지원자들과 차별화되는 강점을 부각하여 경쟁력을 높입니다.자기 PR이 효과적이며 면접 기회는 물론, 합격 확률도 높아집니다.
                </p>

                <h3>기업이 자기 PR에서 주목하는 핵심 요소</h3>
                <p>
                    기업이 자기 PR에서 가장 중요하게 평가하는 요소는 다음과 같습니다.
                </p>

                <p>
                    직무와의 연관성
                    <br>
                    막연한 장점 나열보다는 직무와 관련된 구체적인 사례를 들어 설명하는 것이 중요합니다.
                </p>

                <p>
                    구체적인 성과와 근거
                    <br>
                    "소통을 잘합니다"보다는 "고객 만족도를 20% 향상시킨 경험이 있습니다"처럼 객관적인 데이터나 성과를 포함해야 신뢰도가 높아집니다.
                </p>

                <p>
                    기업과의 적합성
                    <br>
                    해당 기업의 가치와 문화에 적합한 인재인지 평가합니다.기업이 원하는 인재상을 파악하고 그에 맞춰 자기 PR을 작성하는 것이 중요합니다.
                </p>

                <p>
                    논리적인 구성과 간결한 표현
                    <br>
                    읽기 쉽고 논리적인 흐름을 갖춘 자기 PR이 인사 담당자의 관심을 끌 수 있습니다.불필요한 장황한 표현보다, 짧지만 강렬한 문장이 효과적입니다.
                </p>

                <p>
                    자기 PR은 ‘누구나 쓸 수 있는’ 일반적인 내용이 아니라, 자신만의 강점을 담은 맞춤형 메시지여야 합니다. 기업이 주목하는 핵심 요소를 반영하여, 설득력 있는 자기 PR을 완성해
                    봅시다
                </p>

                <h2>효과적인 자기 PR 작성법</h2>
                <p>
                    자기 PR을 작성할 때는 단순한 자기소개나 장점 나열이 아니라, 구체적인 경험과 성과를 바탕으로 지원 직무에 적합한 인재임을 강조하는 것이 중요합니다. 여기에서는 효과적인 자기
                    PR을 작성하는 방법과 피해야 할 실수에 대해 알아보겠습니다.
                </p>

                <h3>강력한 자기 PR을 위한 3가지 핵심 요소</h3>
                <h4>
                    1.구체적인 경험과 성과를 포함할 것
                </h4>
                <p>
                    단순히 "문제 해결 능력이 뛰어납니다"라고 말하는 것이 아니라, 실제 경험을 바탕으로 증명해야 합니다.
                </p>
                <p>
                    예시: <br>
                    "프로젝트 진행 중 예상치 못한 문제를 해결하여 마감 기한을 2주 앞당겼습니다."
                </p>

                <h4>
                    2.기업과 직무에 맞춘 차별화된 강점을 강조할 것
                </h4>
                <p>
                    기업이 원하는 역량과 본인의 경험이 일치하는 부분을 강조하세요.
                </p>
                <p>
                    예시: <br>
                    "귀사의 고객 중심 전략과 저의 고객 경험 관리 역량이 잘 맞아떨어진다고 생각합니다."
                </p>

                <h4>
                    3.논리적인 구조와 명확한 문장을 사용할 것
                </h4>
                <p>
                    자기 PR은 짧고 강렬해야 합니다.
                </p>
                <p>
                    예시: <br>
                    STAR 기법(Situation, Task, Action, Result)을 활용하면 논리적인 구성이 가능합니다.
                </p>


                <h3>
                    자기 PR에서 피해야 할 실수들
                </h3>

                <h4>
                    1.추상적인 표현 사용
                </h4>
                <p>
                    잘못된 표현 : "저는 성실하고 책임감이 강한 사람입니다."올바른 표현 : 매일 팀원들과 목표를 점검하며 프로젝트 일정을 조율했고, 3개월간 마감 지연 없이 업무를 수행했습니다."
                </p>

                <h4>
                    2.너무 장황 하거나 핵심이 없는 글쓰기
                </h4>
                <p>
                    자기 PR은 길다고 좋은 것이 아닙니다. 핵심만 간결하게 전달해야 합니다.기업이 원하는 역량과 무관한 경험을 나열하면 효과가 떨어집니다.
                </p>

                <h4>
                    3.진부한 표현과 클리셰 사용
                </h4>
                <p>
                    "어릴 때부터 꿈꿔온 직업입니다." 같은 진부한 표현은 피하고, 차별화된 경험을 강조하세요.이러한 실수를 피하고, 기업이 원하는 자기 PR을 작성하면 지원서의 경쟁력이 높아질
                    것입니다.
                </p>


                <h2>자기 PR 예시 & 템플릿</h2>
                <p>
                    자기 PR을 작성할 때는 본인의 강점과 기업이 원하는 역량이 잘 맞아떨어진다는 점을 강조하는 것이 중요합니다. 신입과 경력직 지원자의 자기 PR은 접근 방식이 다를 수밖에 없기
                    때문에, 각각의 예시와 템플릿을 제공하겠습니다.
                </p>

                <h3>신입 지원자를 위한 자기 PR 예시</h3>
                <p>
                    신입 지원자의 경우 실무 경험이 부족하기 때문에, 학업, 프로젝트, 아르바이트, 동아리 활동 등을 통해 길러온 역량을 강조하는 것이 중요합니다.
                </p>

                <p>
                    예시:
                    <br>
                    "저는 문제 해결 능력을 바탕으로 팀 내에서 주도적인 역할을 수행하는 인재입니다. 대학 시절, 졸업 프로젝트에서 개발팀을 맡아 4명의 팀원과 협력하여 웹 애플리케이션을
                    개발했습니다. 프로젝트 초기에 기능 설계가 명확하지 않아 일정이 지연될 위기에 처했지만, 팀원들과 논의를 거쳐 역할을 재배분하고, 2주 내로 MVP(최소 기능 제품)를 완성할 수
                    있었습니다. 이 경험을 통해 문제를 분석하고 해결하는 능력을 키웠으며, 협업을 통해 목표를 달성하는 방법을 배웠습니다. 이러한 역량을 바탕으로 귀사의 개발팀에서 기여할 수 있다고
                    확신합니다."
                </p>

                <p>
                    템플릿:
                    <br>
                    한 문장으로 자신을 표현 구체적인 경험(학업, 프로젝트, 아르바이트 등)과 자신의 역할 해결했던 문제와 구체적인 결과 기업에서 어떻게 기여할 수 있는지 연결
                </p>

                <h3>경력직 지원자를 위한 자기 PR 예시</h3>
                <p>
                    경력직 지원자는 본인의 실무 경험을 강조해야 합니다. 특히, 이전 직장에서의 성과와 이를 통해 기업에 어떤 가치를 제공할 수 있는지 명확히 어필하는 것이 중요합니다.
                </p>

                <p>
                    예시:
                    <br>
                    "저는 고객 데이터 분석을 통해 매출 향상을 이끌어낸 마케팅 전문가입니다. 이전 회사에서는 CRM 데이터를 활용하여 고객 세그먼트를 세분화하고, 맞춤형 프로모션을 기획하여 고객
                    재구매율을 30% 향상시킨 경험이 있습니다. 또한, Google Analytics와 SQL을 활용해 웹사이트 방문 데이터를 분석하고, 이를 기반으로 마케팅 전략을 최적화하여 광고
                    효율을 20% 개선한 바 있습니다. 이러한 데이터 분석 및 전략적 사고 역량을 바탕으로 귀사의 마케팅팀에서 고객 경험을 극대화하는 데 기여하고 싶습니다."
                </p>

                <p>
                    템플릿:
                    <br>
                    한 문장으로 본인의 핵심 역량과 강점 요약
                    <br>
                    구체적인 직무 경험 및 성과 수치 포함
                    <br>
                    성과를 달성하기 위해 사용한 방법과 기술 강조
                    <br>
                    이전 경험이 지원하는 직무에서 어떻게 활용될 수 있는지 연결
                    <br>
                    신입과 경력직 모두 자기 PR을 작성할 때는 단순한 자기소개가 아니라, 구체적인 경험과 성과를 바탕으로 기업이 원하는 인재임을 설득하는 것이 핵심입니다.
                </p>


                <h2>차별화된 자기 PR을 위한 팁</h2>
                <p>자기 PR은 단순한 자기소개가 아니라 기업이 원하는 인재상과 본인의 강점이 일치함을 설득하는 과정입니다. 많은 지원자들 사이에서 돋보이기 위해서는 일반적인 내용이 아닌, 차별화된
                    자기 PR을 작성해야 합니다. 다음 팁을 참고하여 한층 더 경쟁력 있는 자기 PR을 완성해보세요.</p>


                <h3>회사 맞춤형 자기 PR 작성법</h3>
                <p>
                    모든 기업이 동일한 인재를 원하는 것은 아닙니다. 따라서, 한 가지 자기 PR을 여러 기업에 그대로 제출하는 것은 좋은 전략이 아닙니다. 지원하는 기업과 직무에 맞춰 자기 PR을
                    맞춤형으로 작성하는 것이 중요합니다.
                </p>

                <h4>1.기업이 원하는 인재상 분석하기</h4>
                <p>
                    기업의 채용 공고, 홈페이지, 미션·비전, 기업 문화 등을 통해 어떤 인재를 원하는지 파악합니다.
                    예를 들어, 어떤 회사는 ‘도전적인 인재’를 원할 수도 있고, 어떤 회사는 ‘꼼꼼한 분석력’을 갖춘 인재를 선호할 수도 있습니다.
                </p>

                <h4>2.직무별 요구 역량 확인하기</h4>
                <p>
                    동일한 직무라도 회사마다 요구하는 역량이 다를 수 있습니다.직무 설명서를 분석하여 요구하는 핵심 역량을 자기 PR에서 강조합니다.
                </p>

                <h4>3.회사에 맞는 키워드 활용하기</h4>
                <p>
                    기업의 가치관과 일치하는 키워드를 자기 PR에 자연스럽게 포함시키면, 보다 맞춤형 지원서로 보일 수 있습니다.예를 들어, 창의성을 강조하는 기업이라면 "새로운 시도를 주도하는
                    경험"을 강조하는 것이 효과적입니다.
                </p>

                <h4>4.기업과의 연결고리를 강조하기</h4>
                <p>
                    본인의 경험과 강점이 해당 기업에서 어떻게 활용될 수 있는지 구체적으로 연결해야 합니다."제 분석력을 활용하여 귀사의 마케팅 전략 최적화에 기여하고 싶습니다."처럼 직접적인 기여
                    포인트를 명확히 작성하는 것이 좋습니다.
                </p>

                <h3>강한 인상을 남기는 문장 구성법</h3>
                <p>
                    자기 PR에서 첫인상이 중요하듯, 문장 구성 방식도 매우 중요합니다. 단순히 경험을 나열하는 것이 아니라, 논리적이고 설득력 있는 문장 구성을 해야 합니다.
                </p>

                <h4>1.첫 문장에서 강한 인상을 남기기</h4>
                <p>
                    "저는 마케팅 전략을 기획하여 고객 재구매율을 30% 향상시킨 경험이 있습니다."
                    <br>
                    "저는 문제 해결 능력을 바탕으로 팀의 생산성을 극대화하는 역할을 해왔습니다."
                </p>


                <h4>2.STAR 기법 활용하기</h4>
                <p>
                    자기 PR을 보다 구체적이고 설득력 있게 작성하려면, STAR 기법을 활용하는 것이 좋습니다.
                </p>

                <p>
                    Situation (상황): 어떤 상황에서 활동했는가?
                    <br>
                    Task (과제): 어떤 문제를 해결해야 했는가?
                    <br>
                    Action (행동): 문제 해결을 위해 무엇을 했는가?
                    <br>
                    Result (결과): 어떤 성과를 냈는가?
                </p>


                <h4>3.숫자를 활용하여 설득력 강화하기</h4>
                <p>
                    "마케팅 캠페인을 운영하여 매출을 증가시켰다." 와 같이 막연한 설명은 설득력이 없어 보일 수 있습니다.예를 들면 "A/B 테스트를 통해 최적화한 광고 캠페인으로 클릭률을 40%
                    증가시켰다." 와 같이 구체적인 수치를 활용하면 신뢰도가 높아지고 인사 담당자가 쉽게 이해 할수 있습니다.
                </p>


                <h4>4.간결하고 명확한 문장 사용하기</h4>
                <p>
                    장황한 설명은 피하고, 한 문장에서 하나의 메시지만 전달하는 것이 중요합니다."저는 데이터 분석을 통해 사용자 경험을 개선하고, 매출을 증가시키는 역할을 했습니다."
                </p>


                <h2>결론: 강력한 자기 PR로 합격률을 높이자</h2>
                <p>
                    자기 PR은 단순한 자기소개가 아니라 기업이 원하는 인재상과 본인의 강점을 연결하는 전략적인 글쓰기입니다. 인사 담당자는 많은 지원서 중에서 회사에 적합한 인재를 빠르게 파악하려고
                    하기 때문에, 명확하고 설득력 있는 자기 PR이 필수적입니다.
                </p>

                <p>
                    자기 PR을 효과적으로 작성하려면 다음과 같은 요소를 기억해야 합니다.
                    <br>
                    1.기업 맞춤형 PR → 지원하는 회사와 직무에 맞춰 차별화된 내용을 작성
                    <br>
                    2.강렬한 첫 문장 → 한 문장으로 자신의 핵심 강점을 강조
                    <br>
                    3.논리적인 구성 (STAR 기법 활용) → 경험을 구체적으로 설명하여 설득력 강화
                    <br>
                    4.구체적인 수치 활용 → 객관적인 성과를 제시하여 신뢰성 향상
                    <br>
                    5.간결하고 명확한 문장 → 불필요한 정보는 줄이고 핵심을 강조
                </p>

                <p>
                    기업과 직무에 맞춰 나만의 강점과 경험을 효과적으로 전달하는 자기 PR을 작성한다면, 인사 담당자의 눈에 띄는 차별화된 지원서를 만들 수 있습니다. 지금까지 배운 팁을 활용하여
                    경쟁력 있는 자기 PR을 완성해 보세요!
                </p>


            </div>

            <div class="articlelist">
                <a href="/kr/resume/article" class="articlelist__link">기사 목록</a>
            </div>

        </section>
    </main>
</template>

<style lang="css" src="@/assets/css/renew_info.css"></style>
<style lang="scss" src="@/assets/scss/article/article.scss"></style>
<script>
export default {
    created: function () {
    }
}
</script>